export enum LogicDependencyMode {
  AllEqual = 1,
  SomeEqual = 2,
}
